import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-zinc-50">
        <Loader2 className="h-6 w-6 animate-spin text-emerald-700" strokeWidth={1.5} />
      </div>
    );
  }
  if (user === false) {
    return <Navigate to={location.pathname === "/" ? "/tanitim" : "/login"} replace />;
  }
  return children;
}
